import type { FC } from 'react';
import { getCDNImageUrl } from '@/helpers/cdn';
import { getRandomDouble } from '../../../helpers';

import {
  ScAnimatedParticlesContainer,
  ScAnimatedParticlesImage,
} from '../styled';

export type Image = {
  src: string;
  position: {
    x: number;
    y: number;
  };
};

export const AnimatedParticles: FC<{ images: Image[] }> = ({ images }) => (
  <ScAnimatedParticlesContainer>
    {images.map(({ src, position }, index) => (
      <ScAnimatedParticlesImage
        alt={`Particle-${index + 1}`}
        delay={getRandomDouble(1.5, 2)}
        key={index}
        positionX={position.x}
        positionY={position.y}
        src={getCDNImageUrl(src)}
      />
    ))}
  </ScAnimatedParticlesContainer>
);
